import type { NowPlaying, PublicStation } from './types';

export interface ProgressState {
  elapsedMs: number;
  durationMs: number;
  percent: number;
}

export function progressFromServerClock(nowPlaying: NowPlaying | null, receivedAtMs: number, nowMs: number): ProgressState | null {
  if (nowPlaying?.expectedEndAt === null || nowPlaying === null) return null;
  const startedAt = Date.parse(nowPlaying.startedAt);
  const expectedEndAt = Date.parse(nowPlaying.expectedEndAt);
  const serverAtReceipt = Date.parse(nowPlaying.serverTime);
  if (![startedAt, expectedEndAt, serverAtReceipt, receivedAtMs, nowMs].every(Number.isFinite) || expectedEndAt <= startedAt) return null;
  const durationMs = expectedEndAt - startedAt;
  const estimatedServerNow = serverAtReceipt + Math.max(0, nowMs - receivedAtMs);
  const elapsedMs = Math.min(durationMs, Math.max(0, estimatedServerNow - startedAt));

  return { elapsedMs, durationMs, percent: (elapsedMs / durationMs) * 100 };
}

export function reconnectDelayMs(attempt: number): number {
  return Math.min(30_000, 1_000 * 2 ** Math.max(0, Math.min(10, attempt)));
}

export function selectInitialStation(stations: readonly PublicStation[], rememberedSlug: string | null): PublicStation | null {
  return stations.find(({ slug }) => slug === rememberedSlug) ?? stations[0] ?? null;
}

export function formatDuration(milliseconds: number): string {
  const totalSeconds = Math.max(0, Math.floor(milliseconds / 1_000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function sleepRemaining(deadlineMs: number | null, nowMs: number): string | null {
  if (deadlineMs === null) return null;
  const remainingMinutes = Math.max(0, Math.ceil((deadlineMs - nowMs) / 60_000));

  return `${remainingMinutes} хв`;
}
